export default __webpack_public_path__ + "d8c089487cb02a2d8f087728e1228800.png";